<template>
  <div class="range-panel">
    <div class="range-panel-block">
      <label class="range-panel-label" for="icons-scale">Размер объектов</label>
      <custom-range-input
        id="icons-scale"
        @input="onIconsScaleChange"
        :inputValue="project.iconsScale"
        min="0.1"
        max="2"
        step="0.1"
      />
    </div>

    <div class="range-panel-block">
      <label class="range-panel-label" for="risk-map-opacity">Прозрачность</label>
      <custom-range-input
        id="risk-map-opacity"
        @input="onOpacityChange"
        :inputValue="opacity"
        min="0.3"
        max="1"
        step="0.1"
      />
    </div>
  </div>
</template>

<script>
import CustomRangeInput from "./ui/CustomRangeInput";
export default {
  props: {
    opacity: [Number, String],
    project: Object,
  },
  components: {
    CustomRangeInput,
  },
  data() {
    return {
      reactiveOpacity: this.opacity,
    };
  },
  methods: {
    onOpacityChange(value) {
      this.reactiveOpacity = value;
      this.$emit("onOpacityChange", value);
    },
    onIconsScaleChange(value) {
      this.$emit("onIconScaleChange", value);
    },
  },
};
</script>

<style scoped>
.range-panel {
  position: absolute;
  left: 21px;
  bottom: 24px;
  display: flex;
  gap: 16px;
  z-index: 10;
}
.range-panel-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.range-panel-label {
  font-size: 12px;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  color: var(--black-color);
  margin: 0;
}
</style>
